import React, { FC } from 'react'
import { ErrorMessage } from 'components/Error'
import { Spacer } from 'components/Utility'
import { ShoppingBagType } from 'types/store'

type Props = {
  shoppingBags: ShoppingBagType[]
}

const ShoppingBagsError: FC<Props> = React.memo((props) => {
  const { shoppingBags } = props
  return (
    <div>
      {shoppingBags.some((shoppingBag) => shoppingBag.name === '') && (
        <>
          <ErrorMessage caution={`レジ袋サイズを入力してください。`} id={'shopping-bag-form'} />
          <Spacer size={12} />
        </>
      )}
    </div>
  )
})

export default ShoppingBagsError
